import React from 'react'
import PropTypes from 'prop-types'
import { Checkbox } from 'antd'
import css from './filter.css'

const ActiveCheckbox = ({
  active,
  onChange,
}) => (
  <div className={css.activeCheckboxContainer}>
    <Checkbox
      key="activeOnly"
      value={active}
      checked={active}
      onChange={({ target: { checked } }) => onChange(checked)}
    >
      Active Only
    </Checkbox>
  </div>
)

ActiveCheckbox.propTypes = {
  active: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default ActiveCheckbox



// WEBPACK FOOTER //
// ./src/Dashboard/Filters/ActiveCheckbox.js